import * as React from 'react';

import type {ChannelType} from 'nutshell-graphql-types';

import type {SourceValues} from '../types';

import {SourceModalContent} from './source-modal-content';

type Props = {
    onClose: () => void;
    onCreateSource: (name: string, channel?: ChannelType | null | undefined) => any;
    isSaving: boolean;
    initialValues?: SourceValues;
};

export function AddSourceModal(props: Props) {
    return (
        <SourceModalContent
            onClose={props.onClose}
            onSubmit={(name: string, channel?: ChannelType | null) => {
                // Create new source, needs to be `null` for `CHANNEL_UNKNOWN`
                props.onCreateSource(name, channel);
            }}
            title='Add a new source'
            buttonText='Create source'
            isSaving={props.isSaving}
            initialValues={props.initialValues}
        />
    );
}
